import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/v2/components/atoms/Button';

const propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    onVlpClick: PropTypes.func,
};
const defaultProps = {
    onVlpClick: null,
};

class VLPPlus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.vlpHash = null;
        this.vlpKey = 'visualiserFragmentID';
        this.validateHashtag = this.validateHashtag.bind(this);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    componentDidMount() {
        if (localStorage) {
            const hashtag = localStorage.getItem(this.vlpKey);

            if (hashtag) {
                this.vlpHash = this.validateHashtag(hashtag.toString());
            }
        }
    }

    validateHashtag = (tag) => {
        const hashtag = tag;

        if (hashtag.charAt(0) !== '#') {
            return null;
        }

        return encodeURI(hashtag);
    };

    stripPrevHashtag = (href) => {
        let newUrl = href;
        const lastHash = href.lastIndexOf('#');

        if (lastHash > 0) {
            newUrl = newUrl.substr(0, lastHash);
        }

        return newUrl;
    };

    onClickHandler = (e) => {
        const { href, onTrackEvent, onVlpClick } = this.props;
        e.preventDefault();
        onTrackEvent();

        if (onVlpClick !== null) {
            onVlpClick();
        }

        if (this.vlpHash !== null) {
            const newUrl = this.stripPrevHashtag(href) + this.vlpHash;

            if (localStorage) {
                localStorage.removeItem(this.vlpKey);
            }

            window.location.href = decodeURI(newUrl);
        } else {
            window.location.href = decodeURI(href);
        }

        return false;
    };

    render() {
        const { href, children } = this.props;
        return (
            <Button variant="secondary-light" href={href} onClick={this.onClickHandler}>
                {children}
            </Button>
        );
    }
}

VLPPlus.propTypes = propTypes;
VLPPlus.defaultProps = defaultProps;

export default VLPPlus;
